import React from 'react';
import { Box } from '@mui/material';

/**
 * Responsive CSS grid — reliable centering and equal columns (MUI v7 Grid broke legacy `item`/`xs`).
 * @param {{ columns?: { xs?: number, sm?: number, md?: number, lg?: number }, gap?: number, sx?: object, children: React.ReactNode }} props
 */
const repeatCols = (n) => `repeat(${n}, minmax(0, 1fr))`;

const CardGrid = ({ columns = { xs: 1, sm: 2, md: 3 }, gap = 3, sx = {}, children }) => {
  const cols = {
    xs: columns.xs ?? 1,
    sm: columns.sm ?? columns.xs ?? 1,
    md: columns.md ?? columns.sm ?? columns.xs ?? 1,
    lg: columns.lg ?? columns.md ?? columns.sm ?? columns.xs ?? 1,
  };

  return (
    <Box
      sx={{
        display: 'grid',
        width: '100%',
        gap,
        alignItems: 'stretch',
        justifyItems: 'stretch',
        gridTemplateColumns: {
          xs: repeatCols(cols.xs),
          sm: repeatCols(cols.sm),
          md: repeatCols(cols.md),
          lg: repeatCols(cols.lg),
        },
        ...sx,
      }}
    >
      {React.Children.map(children, (child) =>
        child ? (
          <Box sx={{ display: 'flex', minWidth: 0, width: '100%' }}>{child}</Box>
        ) : null
      )}
    </Box>
  );
};

export default CardGrid;
